module.exports = __webpack_public_path__ + "static/media/fleet.6559e089.svg";